import { jsx as _jsx } from "react/jsx-runtime";
import { DropDown_Values } from '../../../../../../shared-components/index.js';
import { filterRelevantValues } from '../../utils/utils.js';
export default function RenderLeftSide(props) {
    const relevantValues = filterRelevantValues(props.initialValue);
    return (_jsx("div", { children: props.item && props.item.map((currInput, inputIndex) => (_jsx(DropDown_Values, { selected: props.item && props.item[inputIndex]?.valueId, onSelected: newValue => {
                props.onChangeVariableValue(props.index, inputIndex, newValue);
            }, queryFilter: item => relevantValues.includes(item._id), variable: props.variable }, inputIndex))) }));
}
//# sourceMappingURL=RenderLeftSide.js.map